import React from 'react';
import { Section } from './Section';
export function HowItWorksSection() {
  const steps = [{
    day: 'Día 1',
    title: 'Drena',
    desc: 'Abrimos las vías de eliminación de toxinas y sodio.'
  }, {
    day: 'Día 2',
    title: 'Reset',
    desc: 'Estabilizamos tus hormonas para detener la retención.'
  }, {
    day: 'Día 3',
    title: 'Sella',
    desc: 'Consolidamos la ligereza y recuperamos tu energía vital.'
  }];
  return <Section className="bg-cream" data-id="element-74">
      <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-12 text-center" data-id="element-75">
        ¿Cómo funciona?
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-76">
        {steps.map((step, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-md border border-sage text-center relative overflow-hidden" data-id="element-77">
            <div className="absolute top-0 left-0 w-full h-2 bg-gold" data-id="element-78"></div>
            <span className="text-gold font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-79">
              {step.day}
            </span>
            <h3 className="font-serif text-2xl font-bold text-forest mb-4" data-id="element-80">
              {step.title}
            </h3>
            <p className="text-gray-600" data-id="element-81">{step.desc}</p>
          </div>)}
      </div>
    </Section>;
}